module.exports = __webpack_public_path__ + "media/1-5.2c30ed2c.mp3";